import React from 'react';
import { Link } from 'react-router-dom';

const sections = [
  {
    title: '1. What We Collect',
    body: `When you create an account we collect your name, email address, and (if you sign in with Google) your Google profile name and email. Gameplay data such as progress, settings, and achievements may be stored to sync your experience across devices. We do not collect payment card details directly — those are handled by the app stores.`,
  },
  {
    title: '2. How We Use Your Data',
    body: `We use your data to create and secure your account, save and sync your game progress, respond to support requests, and improve the Game. We do not sell your personal data.`,
  },
  {
    title: '3. Authentication Providers',
    body: `Account creation and login are handled by Firebase Authentication (Google). When you use "Continue with Google," Google shares your name, email, and profile photo with us as permitted by your Google account settings.`,
  },
  {
    title: '4. Data Storage & Security',
    body: `Account and gameplay data is stored using Firebase (Google Cloud infrastructure) with industry-standard security practices. No method of transmission or storage is 100% secure, but we take reasonable steps to protect your information.`,
  },
  {
    title: '5. Data Retention',
    body: `We retain account data for as long as your account is active. You can request deletion of your account and associated data at any time via the Support page.`,
  },
  {
    title: '6. Children’s Privacy',
    body: `HiveFall is not directed at children under 13, and we do not knowingly collect personal information from children under 13. If you believe a child has provided us personal data, contact us and we will remove it.`,
  },
  {
    title: '7. Your Rights',
    body: `Depending on your location, you may have the right to access, correct, export, or delete your personal data. Contact us to exercise these rights.`,
  },
  {
    title: '8. Third-Party Links',
    body: `Our website and app store listings may link to third-party sites (such as Google Play or the App Store). We are not responsible for the privacy practices of those sites.`,
  },
  {
    title: '9. Changes to This Policy',
    body: `We may update this Privacy Policy as the Game evolves. Material changes will be reflected by updating the date at the top of this page.`,
  },
  {
    title: '10. Contact',
    body: `Questions about this policy or your data? Reach us via the Support page or email support@playhivefall.com.`,
  },
];

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen" style={{ background: 'var(--brand-bg)' }}>
      <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6 lg:px-8">
        <span className="pill">Legal</span>
        <h1 className="page-title section-gap">Privacy Policy</h1>
        <p className="page-subtitle">
          Last updated August 8, 2026. This policy explains what data HiveFall collects and how it's used.
        </p>

        <div className="mt-8 space-y-6">
          {sections.map((s) => (
            <div key={s.title} className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
              <h2 className="text-base font-black text-slate-900">{s.title}</h2>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.body}</p>
            </div>
          ))}
        </div>

        <Link to="/" className="mt-8 inline-block text-sm font-bold text-[var(--brand-primary)] hover:underline">
          ← Back to home
        </Link>
      </div>
    </div>
  );
}
